import InvoiceTotalsDetailLabel
	from "~/modules/billing/components/InvoiceTotalsDetail/components/InvoiceTotalsDetailLabel";
import InvoiceTotalsDetailValue
	from "~/modules/billing/components/InvoiceTotalsDetail/components/InvoiceTotalsDetailValue";

type Props = {
	bold?: boolean;
	children?: React.ReactNode;
	label: string;
};

const InvoiceTotalsDetail = ({ bold=false, children, label }: Props) => {
	return <>
		<InvoiceTotalsDetailLabel bold={bold}>{label}</InvoiceTotalsDetailLabel>
		<InvoiceTotalsDetailValue bold={bold}>{children}</InvoiceTotalsDetailValue>
	</>;
};

export default InvoiceTotalsDetail;